module.exports = __webpack_public_path__ + "static/media/neutral_tan_5150.png.95928b91.webp";